<!-- Add Ticker to Watchlist Dialog -->
<app-watchlist-add-ticker-dialog></app-watchlist-add-ticker-dialog>

<!-- Icon Button -->
<p-button
  icon="pi pi-plus"
  (onClick)="openAddDialog()"
  [text]="true"
  severity="success"
  pTooltip="Add to Watchlist"
  tooltipPosition="top">
</p-button>
